import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { DatePipe } from '@angular/common';

export interface ApiImage {
  id: string;
  id_user:number;
  name: string;
  createdAt: Date;
  url: string;
}
@Injectable({
  providedIn: 'root'
})
export class ApiService {

  myDate = new Date();
  constructor(private http: HttpClient,private datePipe:DatePipe) { }

  uploadImage(blobData, name, ext) {
    const formData = new FormData();
    formData.append('file', blobData, `myimage.${ext}`);
    formData.append('name', name);
 
    return this.http.post(`${environment.urlUserimg}?opcion=1`, formData);
  }

  uploadImageFile(file: File,id,auth_key,tipo) {
    
  const headersconf = {
    
      //'enctype': 'multipart/form-data;',
      //'Accept': 'plain/text',
      //'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT',
      //'Access-Control-Allow-Headers': 'Authorization, Origin, Content-Type, X-CSRF-Token',
    };
    let httpOptions = {
      headers: new HttpHeaders(
        headersconf
      )
  };
  
    const ext = file.name.split('.').pop();
    const formData = new FormData();
    //formData.append('imagen', file, `portada.${ext}`);
    formData.append("UserImg[name]", file, file.name+'');
    //formData.append('name', file.name);
    let myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    formData.append('id', id);
    formData.append('UserImg[id_user]', id);
    formData.append('UserImg[creatcreatedAt]', myDate);
    formData.append('UserImg[url]', 'assets/user/avatar');
    formData.append('UserImg[tipo]', tipo);
    formData.append('tipo', tipo);
    formData.append('auth_key', auth_key);
    return this.http.post(`${environment.urlUserimg}?opcion=1`, formData,httpOptions);
  }
  get(id,auth_key) {
    const formData = new FormData();
    formData.append('id', id);
    formData.append('auth_key', auth_key);
    return this.http.post(`${environment.urlUserimg}?opcion=2`, formData);
  }
}
